import { useState, useEffect, useCallback } from 'react';
import { fetchAdminDashboard } from '../../../api/analytics.api';
import logger from '../../../utils/logger';

export function useDashboardData() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadData = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const dashboardData = await fetchAdminDashboard();
      setData(dashboardData);
      logger.log('Dashboard data loaded:', dashboardData);
    } catch (err) {
      logger.error('Error fetching dashboard data:', err);
      setError(err.message || 'Erreur lors du chargement des données');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadData();
  }, [loadData]);

  return { data, loading, error, refetch: loadData };
}
